const data = {
    "Main": "Bosh sahifa",
    "Transportation organization": "Transportni tashkillashtirish",
    "Dispatching": "Dispetcherizatsiya",
    "Sales": "Savdo",
    "Administration": "Ma'muriyat",
    "Logout": "Chiqish",
    "Search": "Qidirish",

    "Trips": "Safarlar",
    "Reporting": "Hisobot",

    "Logs": "Loglar",
    "Cashier action": "Kassir harakati",

    "Pricing": "Raqobatchilar",
    "Tariffs": "Tariflar",
    "Privileges": "Imtiyozlar",
    "Baggage": "Bagaj",
    "Attach baggage": "Bagaj biriktirish",
    "Passenger ID": "Yo'lovchi ID",
    "Baggage count": "Bagaj soni",
    "Baggage id": "Bagaj ID",
    "Baggage attached": "Bagaj biriktirildi",
    "Previously attached baggage": "Oldin biriktirilgan bagajlar",
    "Newly attached baggage": "Yangi biriktirilgan bagajlar",
    "Print all": "Barchasini chop etish",
    "Created at": "Yaratilgan sana",
    "Bus seat": "O'rindiq",
    "Attach": "Biriktirish",
    "Services": "Xizmatlar",

    "Profile": "Profil",
    "My profile": "Mening profilim",

    "Sales reporting": "Savdo hisobotlari",
    "Online sales reporting": "Onlayn savdo hisobotlari",
    "Dispatch reporting": "Dispetcher hisoboti",
    "Transporter reports": "Tashuvchi hisoboti",
    "Reports for Min. Trans.": "Trans. Vaz. uchun hisbot",
    "Reports for Validator.": "Tekshiruvchi hisoboti",

    "Cashier's workplace": "Kassir ish joyi",
    "Ticket selling": "Chipta sotish",
    "Armor redemption": "Band qilish",
    "Ticket return": "Chiptalarni qaytarish",
    "Restore ticket": "Chiptani qayta tiklash",

    "Schedule": "Jadval",
    "Areas": "Maydonlar",
    "Bus terminals": "Avtovokzal",
    "Routes": "Yo'nalishlar",
    "Schedule trips": "Safarlarni rejalashtirish",

    "Settings": "Sozlamalar",
    "Options": "Parametrlar",
    "Returns": "Qaytariladi",
    "Booking": "Bron qilish",
    "Booking List": "Bronlar ro'yxati",
    "Work with transporter": "Tashuvchilar bilan ishlash",

    "Transporter": "Tashuvchi",
    "Buses": "Avtobuslar",
    "Bus types": "Avtobus turlari",

    "Employees": "Xodimlar",
    "Roles": "Rollar",
    "API Clients": "Клиенты API",

    "Creation - Editing": "Yaratilish - Tahrirlash",
    "Baggage (Editing)": "Bagaj (reja)",
    "Save and close": "Yozing va yoping",
    "Fixed amount": "Ruxsat etilgan miqdor",
    "Interest Amount": "Foiz miqdori",
    "Amount depending on km": "Miqdori km ga bog'liq",
    "Title": "Nomi",
    "Weight to (kg)": "Og'irligi (kg)",
    "Step (km)": "Bosqich (km)",
    "Additional settings": "Qo'shimcha sozlamalar",
    "From (km)": "Dan (km)",
    "To (km)": "Gacha (км)",
    "Price for this step": "Ushbu qadamning narxi",
    "Price": "Narxi",
    "Percent": "Prosent",
    "Action": "Amal",
    "Reservation fee": "Bronga qo'shimcha to'lov",
    "bag for a ticket": "sum biletga",
    "It is allowed to book more than 1 place for a cashier": "Kassir uchun 1dan ortiq joyni bronga kiritish mumkin",
    "Not": "Yo'q",
    "Passenger personal data required": "Yo'lovchi shaxsiy ma'lumotlari kerak",
    "Required": "Majburiy",
    "Not required": "Majburiy emas",
    "Places are again available for sale for": "Joylar yana sotuvga chiqariladi",
    "minutes before departure": "chiqishidan bir necha daqiqa oldin",
    "Booking is removed through": "Bron  olib tashlanadi",
    "minutes": "minut",
    "Yes": "Ha",
    "No": "Yo'q",
    "Editing": "O'zgartirish",
    "Creature": "Yaratish",
    "buses": "avtobuslarni",
    "This field is required": "Bu maydon talab qilinadi",
    "Model": "Model",
    "Driver": "Haydovchi",
    "Number bus": "Avtobus raqami",
    "Create": "Yaratish",
    "Transporters": "Tashuvchilar",
    "Number": "Raqam",
    "Status": "Holat",
    "Active": "Faol",
    "Inactive": "Faol emas",
    "Turn off": "O'chirib qo'ying",
    "Loading": "Yuklanmoqda",
    "Choose a transporter": "Tashuvchi tanlang",
    "Choose a bus model": "Avtobus modelini tanlang",
    "Choose a driver": "Haydovchini tanlang",

    "Creation": "Yaratilish",
    "Types of buses (creation - editing)": "Avtobus turlari (yaratish - tahrirlash)",
    "How many floors": "Qancha qavat",
    "First floor": "Birinchi qavat",
    "Second floor": "Ikkinchi qavat",
    "Swap From": "bilan almashtirish",
    "Created place": "Joyni yaratish",
    "Created a place for the disabled": "Nogironlar uchun joy yaratildi",
    "Created place for passengers with children": "Bolalar bilan yo'lovchilar uchun joy yaratildi",
    "Floors": "Qavatlar",
    "Create a new type": "Yangi turni yarating",
    "Users": "Foydalanuvchilar",
    "Name": "Ism",
    "Phone number": "Telefon raqami",
    "Type": "Turi",
    "Status user": "Foydalanuvchi holati",
    "Confirm the password": "Parolni tasdiqlang",
    "Select user type": "Foydalanuchi turini tanlang",
    "Refresh": "Yangilash",
    "Old Password": "Eski parol",
    "Password": "Parol",
    "Employee's role": "Xodimning roli",
    "Add roles": "Rol qo'shish",
    "New Password": "Yangi parol",
    "Confirmed Password": "Parolnio takrorlash",
    "Your password has been successfully updated": "Siznign paroling muvaffaqiyatli yangilandi",
    "Role users": "Foydalanuvchi rollari",
    "Number of permissions": "Ruxsatlar soni",
    "Number of users": "Foydalanuchilar soni",
    "User Roles (Creation)": "Foydalanuvchi roli (yaratilish)",
    "Please select at least one permission": "Iltimos, kamida bitta ruxsatni tanlang",
    "additional trips": "qo'shimcha reyslar",
    "Actualize": "Haqiqiylashtirish",
    "Send trips": "Raysni jo'natish",
    "Cancel trips": "Reysni bekor qilish",
    "Change trips": "Reysni o'zgartirish",
    "Has arrived": "Keldi",
    "Statement": "Rasmiy hisobot",
    "List": "Ro'yxat",
    "Passenger": "Yo'lovchi",
    "Passengers": "Yo'lovchilar",
    "Export to Excel": "Excel ga export",
    "Select": "Tanlang",
    "Trip date": "Reyslar vaqti",
    "Point of departure": "Jo'nash joyi",
    "Select stations": "Stantsiyalarni tanlang",
    "date": "Sana",
    "Capacity": "Sig'imi",
    "Number of occupied places": "Egallagan joylar soni",
    "Platform": "Platformalar",
    "Amount": "Summa",
    "Total amount": "Umumiy summa",
    "trip": "reys",
    "To send": "Jo'natish",
    "Bus number": "Avtobus raqami",
    "Bus brand": "Avtobus raqami",
    "Cancel": "bekor qilish",
    "Place": "Joy",
    "Cost": "Narxi",
    "You cannot disable this trip because it has active passengers.": "Siz ushbu safarni o'chirib qo'ya olmaysiz, chunki u faol yo'lovchilarga ega.",
    "STATEMENT": "RASMIY HISOBOT",
    "LIST": "RO\"YXAT",
    "Passengers transported in international road transport": "Yo'lovchilar xalqaro avtomobil tashishda tashiladi",
    "attached to the ticket list": "chiptalar ro'yxatiga biriktirilgan",
    "Date and time of departure": "Ketish sanasi va vaqti",
    "Bus model": "Avtobus modeli",
    "Trip": "Reys",
    "Issued by": "Chiqarilgan",
    "Departure": "Jo'natilgan",
    "Number of citizenship": "Fuqarolik bo'yicha soni",
    "FULL NAME": "F.I.O",
    "Places": "Joylar",
    "Year of birth": "Tug'ulgan sana",
    "Passport Series and No.": "Pasport seriyasi va raqami",
    "Citizenship": "Fuqarolik",
    "From where": "Qayerdan",
    "Until where": "Qayergacha",
    "Ticket price": "Chipta narxi",
    "Tickets": "Chiptalar",
    "Total amount": "Umumiy miqdori",

    "Loading data": "Ma'lumotlar yuklanmoqda",
    "Route": "Yo'nalish",
    "Departure time": "Chiqish vaqti",
    "Price entry": "Narxlar kiritilishi",
    "Name ATP": "ATP nomi",
    "INN": "ИНН",
    "VAT": "НДС",
    "Class code": "ИКПУ",
    "Package code": "Код упаковки",
    "Bank": "Bank",
    "MFO": "MFO",
    "Checking account": "Hisob raqami",
    "Percentage per passenger": "Bir yo'lovchi uchun foiz",
    "Percentage per baggage": "Bagaj uchun foiz",
    "Price / km": "Narx / km",
    "Find": "Qidirish",
    "Locality": "Aholi punkti",
    "Adress": "Manzil",
    "Operation mode": "Ish tartibi",
    "Coordinates": "Koordinatalari",
    "Place of bus station (optional)": "Avtobus bekatlarining joylashuvi (ixtiyoriy)",
    "Also known as": "Bundan tashqari, huddi",
    "day": "kun",
    "Pre-sale fee": "Oldindan sotish uchun yig'im",
    "sum": "so‘m",
    "Presale - for sale for more than": "Oldindan sotish - ko'proq sotuvga chiqariladi",
    "o'clock": "soat",
    "Reserved seats": "Rezervlangan o'rindiqlar",
    "become available for": "uchun foydalanish mumkin",
    "minutes before sending": "yuborishdan oldin daqiqa",
    "Customize information board color scheme": "Ma'lumot kartasi ranglarini moslashtiring",
    "Background 1": "Orqa fon 1",
    "Text color 1": "Tekst rangi 1",
    "Background 2": "Orqa fon 2",
    "Text color 2": "Tekst rangi 2",
    "Show report": "Hisobotlarda ko'rsatilsin",
    "Schedule Flights (Creation)": "Reyslarni rejalashtirish (yaratilish)",
    "Choose a route": "Yo'nalishni tanlang",
    "Trip number": "Reys nomer",
    "Arrival": "Kelishi",
    "On the way": "Yo'lda",
    "Each": "Har bir",
    "Mon": "Du",
    "Tu": "Se",
    "We": "Ch",
    "Th": "Pa",
    "Fr": "Ju",
    "Sa": "Sh",
    "Su": "Ya",
    "Various": "Har xil",
    "Even": "Juflar",
    "Odd": "Toqlar",
    "For example 1-5, 9, 13": "Masalan 1-5, 9, 13",
    "Days": "Дни",
    "Beginning with": "Boshlanish vaqti",
    "Ends at": "Tugash vaqti",
    "Choose a bus": "Avtobusni tanlang",
    "Automatic update": "Avtomatik yangilash",
    "International flight": "Xalqaro reys",
    "Parking": "To'xtov joyi",
    "Send": "Jo'n.",
    "Comment": "Fikr",
    "Choose a rate": 'Tarifni tanlang',
    "Flights schedule": "Reyslar jadvali",
    "Deactivate": "O'chirish",
    "Destination": "Manzil",
    "Regularity": "Muntazamlik",
    "Turned off": "Yopiq",
    "Schedule Flights (Change)": "Parvozlarni rejalashtirish (o'zgartirish)",
    "Change": "O'zgartirish",
    "Clear trail flights and generate new ones": "Izni tozalang reyslar va yangilarini ishlab chiqaradi",
    "Filter": "Filtrni tanlang",
    "- day": "- kun",
    "Route number": "Yo'nalish raqami",
    "Add station": "Stansiyani qo'shish",
    "Select a station to add": "Qo'shiladigan stantsiyani tanlang",
    "Choose": "Tanlang",
    "Km": "Km",
    "Tit.": "Nomi",
    "Fault return": "Aybi bo'yicha qaytarish",
    "Fine": "Shtraf",
    "ATP": "ATP",
    "Passenger after flight departure": "Yo'lovchi parvozdan keyin yo'lovchi",
    "The return of the fault of the passenger to the departure of the flight": "Yo'lovchining aybi tufayli parvozni tark etishga qaytarish",
    "Creating benefits": "Manfaatlar yaratish",
    "Route Name": "Yo'nalish nomie",
    "Write down": "Yozish",
    "Add": "Qo'shish",
    "Bus terminal": "Avtovokzal",
    "Login": "Login",
    "Enter": "Kirish",
    "Location": "Turgan joyi",
    "Geography": "Geografiya",
    "Prochee": "Boshqalar",
    "Cashiers": "Kassirlar",
    "Payment System": "To'lov tizimi",
    "Full name": "Ism Familiya",
    "Passport number": "Pasport raqami",
    "Number place": "Joy nomeri",
    "Trips (creation)": "Reys (o'zgartirish)",
    "Bus": "Avtobus",
    "Region": "Viloyat",
    "Stations" : "Stansiya",
    "Privilege" : "Imtiyozlar",
    "Return service" : "Xizmatni qaytarish",
    "Bus type" : "Avtobus turi",
    'Country': 'Davlat',
    'Conductor' : 'Konduktor',
    'Reports' : 'Hisobotlar',
    'Reversals': 'Qaytarilgan biletlar',
    "You are about to delete the record! \nAre you sure?" : 'Yozuvni o\'chirib tashlamoqchisiz!\n' +
        'Ishonchingiz komilmi?',
    "Registration" : "Registrasiya",
    "Tariff": "tarif",
    "Fine (percentage)" : "Shtraf(prosentda)",
    "No. ticket" : "Chipta raqami",
    "Role has been saved successfully" : "Rol muvaffaqiyatli saqlandi.",
    "Select service type" : "Xizmat turini tanlang",
    "Choose a baggage type" : "Bagaj turini tanlang",
    "Name trip" : "Reys nomi",
    "Choose region" : "Viloyat nomi",
    "Place of residence" : "Ro'yxatdan o'tgan manzili",
    "Save" : "Saqlash",
    "Do you really want to delete this bus station?" : "Siz ushbu avtobus bekatini o'chirmoqchimisiz?",
    "Settings saved!" : "Sozlamalar saqlandi!",
    "Depth of sales" : "Sotish chuqurligi",
    "Presale": "Oldindan savdo",
    "Place quotas" : "Joylarda kvotalar",
    "Bus station services" : "Avtovokzal xizmatlari",
    "Required " : "Majburiy",
    "Show in reports": "Hisobotlarni ko'rsatish",
    "Bus station taxes": "Avtovokzal yig'imi",
    "Bus station collection" : "Avtovokzal yig'imi",
    "All passengers moved to a new journey." : "Barcha yo'lovchilar yangi safarga ko'chishdi.",
    "HOT !!! Do you really want to delete all trips that start tomorrow and generate new ones?" : "EHTIYOT BO'LING !!! Ertaga boshlaydigan barcha sayohatlarni o'chirishni va yangilarini yaratishni xohlaysizmi?",
    'Successfully!!!' : 'Muvaffaqiyatli!',
    'Saved!' : 'Saqlandi!',
    'min' : 'min',
    'h' : 'soat',
    'Basic' : 'Asosiy',
    'Do you really want to delete flight schedules?' : 'Parvoz jadvallarini o\'chirishni xohlaysizmi?',
    "You are about to delete the record \nAre you sure?" : "Yozuvni o'chirib tashlamoqchisiz! \n Ishonchingiz komilmi?",
    "Surname" : "Familiya",
    "Middle name" : "Otasini ismi",
    "Do you really want to change the status?" : "Siz haqiqatdan ham holatimi o'zgartirmoqchimisiz?",
    "Changed status" : "Holatni o'zgartish",
    "Failed to change" : "O'zgarish amalga oshmadi",
    "Do you really want to delete?" : "Siz haqiqatdan ham yo'q qilishni xohlaysizmi?",
    "Departure date" : "Chiqish sanasi",
    "Number of passengers" : "Yo'lovchilar soni",
    "Generate month report" : "Oylik hisobot tuzish",
    "Generate daily report" : "Kundalik hisobotni yarating",
    "Filter by date from" : "Sana bo'yicha filtr",
    "by" : "bo'yicha",
    "To form" : "Yaratish",
    "Car number" : "Avto raqami",
    "Count beat" : "Кол. бил",
    "Plan" : "Plan",
    "Fact" : "Fakt",
    "Pass" : "Yo'l",
    "Bag" : "Bag",
    "Full name of the driver" : "Haydovchini F.I.O si",
    "Cash" : "Naqd",
    "Term" : "Term",
    "Print out" : "Chiqarish",
    "Total": "Jami",
    "Last day" : "Oxirgi kun",
    "since the beginning of the week" : "Haftaning boshidan beri",
    "from the beginning of the month" : "oyning boshidan boshlab",
    "from the beginning of the year" : "yil boshidan beri",
    "trips" : "Reyslar",
    "passenger" : "Yo'lovchi",
    "all places" : "hamma joylar",
    "Name of the Cashier" : "Kassir F.I.O si",
    "Sold tickets": "Sotilgan chiptalar",
    "Including" : "Shu jumladan",
    "Returned tickets" : "Qaytgan chiptalar",
    "Sold tickets with no refund" : "Qaytarilmasdan chipta sotilgan",
    "Number of booking.\n places" : "Bron. qilingan joylar soni",
    "count" : "soni",
    "amount":"summa",
    "Sold Services" : "Sotilgan xizmatlar",
    "baggage amount" : "Bagaj summasi",
    "Cashier" : "Kassir",
    "All passengers" : "Hamma yo'lovchilar",
    "Village of passengers" : "O'tirgan yo'lovchilar soni",
    "No passengers" : "O'tirmagan yo'lovchilar soni",
    "Booked seats" : "Bron qilingan joylar",
    "Canceled tickets" : "Bekor qilingan biletlar",
    "others" : "boshqalar",
    "Selected passengers" : "Tanlangan yo'lovchilar",
    "Selected Village of passengers" : "Tanlangan O'tirgan yo'lovchilar",
    "Selected No passengers village" : "Tanlangan O'tirmagan yo'lovchilar",
    "Selected Canceled Tickets" : "Tanlangan Bekor qilingan biletlar",
    "Selected Returned Tickets" : "Tanlangan Qaytarilgan biletlar",
    "Selected others" : "Tanlangan boshqalar",
    "Amount of selected passengers" : "Tanlangan yo'lochilar summasi",
    "No reports" : "Hisobot yo'q",
    "Everything" : "Hammasi",
    "Village" : "O'tirgan",
    "Not village" : "O'tirmagan",
    "Booked" : "Bron qilingan",
    "Canceled" : "Bekor qilindi",
    "Cancelled" : "Bekor qilingan",
    "Returned" : "Qaytarilgan",
    "other" : "boshqalar",
    "Armored" : "Bron",
    "Did not come" : "Kelmagan",
    "Had arrived" : "Kelgan",
    "Canceled for non-payment" : "To'lanmaslik uchun bekor qilingan",
    "Validators report" : "Tekshiruvchi hisoboti",
    "Name of Validator" : "Tekshiruvchi F.I.O si",
    "Trip time" : "Reys vaqti",
    "minimum length is 3" : "minimal uzunligi 3",
    "maximum length is 150" : "maksimal uzunligi 150",
    "can only be used" : "faqat ishlatilishi mumkin",
    "required field" : "kerakli maydon",
    "cyrillic letters" : "Kirill harflari",
    "latin letters" : "Lotin harflari",
    "Do you really want to delete this flight?" : "Ushbu resyni chindan ham o'chirib tashlamoqchimisiz?",
    "Passenger removed!" : "Yo'lovchi o'chirilgan!",
    "Trip has been created successfully" : "Reys muvaffaqiyatli yaratildi",
    "Arrived" : "Kelgan",
    "You are about to delete the record!\nAre you sure?": "Yozuvni o'chirib tashlamoqchisiz!\n" +
        "Ishonchingiz komilmi?",
    "This stop has already been added to the route." : "Ushbu bekat allaqachon marshrutga qo'shilgan.",
    "Count users" : "Foydalanuvchilar soni",
    "Back": "Orqaga",

    "For a passenger ticket": "Yo'lovchiga",
    "For trip": "Reysga",
    "Baggage selling" : "Yuklar",
    'Trip id' : "Rays #",
    'Departing' : "Jo'nash stantsiyasi",
    'Arriving' : "Yetib borish stantsiyasi",
    'Passenger name' : "Xaridor",
    'Sold time' : "Xarid qilish vaqti",

    'Free baggage allowance international': "Bagajni bepul olib o'tish miqdori (xalqaro reyslarga) (kg)",
    'Free baggage allowance local': "Bagajni bepul olib o'tish miqdori (ichki reyslarga) (kg)",
    'Max baggage allowance international': "Olib o'tish ruxsat etilgan og`irlik (xalqaro reyslarga) (kg)",
    'Max baggage allowance local': "Olib o'tish ruxsat etilgan og'irlik (ichki reyslarga) (kg)",
    'Free baggage allowance': "Bagajni bepul olib o'tish miqdori (kg)",
    'Max baggage allowance': "Olib o'tish ruxsat etilgan og'irlik (kg)",
    'Paid': "To'landi",
    'Baggage id': 'Bagaj #',
    'Baggage weight': "Og'irlik",
    'Tariff defined baggage price': "Tarif bo'yicha bagaj narxi (kg)",

    "Select a trip for baggage": "Yuk uchun raysni tanlang",
    "Pre-tickets sold": "Oldindan chiptalar sotildi",
    "Service": "Xizmat",
    "sum return": "sum qaytish",
    "income": "kirim",
    "cash": "naqd pul",
    "term": "muddatli",
    "total": "jami",
    "Selected Reserved Seats": "Tanlangan joylar",
    "Selected  others": "Boshqa tanlanganlar",
    "Phone": "Телефон",
    "Sold in": "Sotilgan",
    "Updated in": "Yangilandi",
    'Search geo zone': 'Geo hududlar qidirish',
    'type to search geo zone..': 'geo hudud nomini kiriting',
    'Pay': "To'lov",
    'Station name': "Bekat nomi",
    "Total tickets sold today": "Bugun sotilgan jami chiptalar",
    "Time":"Vaqt",
    "Ticket Recovery":"Chiptalarni tiklash",
    "Empty seats":"Bo'sh joylar",
    "No trips":"Reyislar yo'q",
    "Check ticket":"Chiptani tekshiring",
    "Number of ticket":"Chipta raqami",
    "Search by last name":"Familiyasi bo'yicha qidirish",
    "Ticket Details":"Chipta ma'lumotlari",
    "Additional fields":"Qo'shimcha maydonlar",
    "Search flights":"Reyslarni qidirish",
    "Baggage weight in kg":"Yukning vazni kg",
    "Calculate the cost":"Xarajatni hisoblang",
    "Passport":"Pasport",
    "With baby":"Kichkintoy bilan",
    "No reserved places found with this reservation! Check the correct order number":"Ushbu buyurtma bilan zaxiralangan joy topilmadi! To'g'ri buyurtma raqamini tekshiring",
    "Cashier's Logs":"Kassir jurnallari",
    "Cashier Actions":"Kassir ishlari",
    "Description":"Ta'rif",
    "Action Details":"Harakat tafsilotlari",
    "No date":"Sana yo‘q",
    "Purchase":"Xarid qilish",
    "Book now":"Bron qilish",
    "Flight will be closed through":"Reys yopilishiga qolgan vaqt",
    "Ticket sales time for this trip is over":"Ushbu sayohat uchun chiptalarni sotish vaqti tugadi",
    "Flight info":"Reys haqida ma'lumot",
    "Free":"Bo'sh",
    "Reserved":"Rezervlangan",
    "Sold":"Sotilgan",
    "Sold (male)":"Sotilgan(erkak)",
    "Sold (female)":"Sotilgan(ayol)",
    "Storey": "Qavat",

    "Code": "Kodi",

    "Gender": "Jinsi",
    "Male": "Erkak",
    "Female": "Ayol",
    "Gender is required": "Jinsni tanlash majburiy",
    "Information found": "Ma'lumot topildi",
    "Information not found": "Ma'lumot topilmadi",
    "Internal server error": "Serverning ichki xatoligi",
    "Full name": "F.I.Sh",
    "Application ID": "Ariza ID",
    "Application date": "Ariza sanasi",
    "Privilege category": "Toifa",
    "Records": "Yozuvlar",
    "Validity period": "Amal qilish muddati",
    "Privilege check": "Imtiyozni tekshirish",
    "Check": "Tekshirish",
    "Checking": "Tekshirilmoqda",
    "All privilege checks": "Barcha imtiyozlarni tekshirish",
    "Date of birth": "Tug‘ilgan sana",
    "Checking all privileges. Please wait...": "Barcha imtiyozlar tekshirilmoqda. Iltimos, kuting...",
    "Total": "Jami",
    "Found": "Topildi",
    "Errors": "Xatolar",
    "Debug response": "Debug javobi",
    "PINFL must contain 14 digits": "PINFL 14 ta raqamdan iborat bo‘lishi kerak",
    "PINFL is required for a privilege ticket": "Imtiyozli chipta uchun PINFL kiritilishi shart",
    "A companion requires exactly one primary privileged passenger in the order": "Hamroh uchun orderda aynan bitta asosiy imtiyozli yo‘lovchi bo‘lishi shart",
    "Only one companion is allowed for a primary privileged passenger": "Bitta asosiy imtiyozli yo‘lovchiga faqat bitta hamroh biriktirish mumkin",
    "Enter date of birth in YYYY-MM-DD format": "Tug‘ilgan sanani YYYY-MM-DD formatida kiriting",
    "Privilege check could not be completed": "Imtiyozlarni tekshirishni bajarib bo‘lmadi",
    "Not found": "Topilmadi",
    "Response received": "Javob olindi",
    "Partial": "Qisman",
    "Error": "Xato",
    "Chernobyl radiation illness": "Chernobil AES oqibatidagi nurlanish kasalligi",
    "Nuclear radiation veteran": "Yadro nurlanishi faxriysi",
    "Elderly disabled needing care": "Parvarishga muhtoj keksalar va nogironligi bo‘lgan shaxslar",
    "Accompanying person": "Hamroh shaxs",
    "Student": "Talaba",
    "Disabled youth vocational training": "Nogironligi bo‘lgan yoshlarning kasb-hunar ta’limi",
    "Social registry youth competition": "Ijtimoiy reyestrdagi yoshlar musobaqasi",

    "Close": "Yopish",
    "Reserved seats become available in": "Band qilingan joylar bo‘shashiga qolgan vaqt",
    "Passport data is required for international trips": "Xalqaro reyslarda pasport ma’lumotlarini to‘ldirish shart",
    "Maximum one seat": "Ko‘pi bilan bitta joy",
    "Passenger personal data": "Yo‘lovchining shaxsiy ma’lumotlari",
    "Regular": "Oddiy",
    "Passenger type": "Yo‘lovchi turi",
    "Passport details must be filled in and unique": "Pasport ma’lumotlari to‘ldirilishi va takrorlanmasligi kerak",
    "Enter a comment": "Izoh kiriting",
    "With a child": "Bola bilan",
    "Without a child": "Bolasiz",
    "Payment": "To‘lov",
    "Amount to pay": "To‘lanadigan summa",
    "Received": "Qabul qilindi",
    "Change due": "Qaytim",
    "Payment type": "To‘lov turi",
    "By card": "Plastik karta orqali",
    "Pay": "To‘lash",
    "Pay with PIN pad": "PIN-pad orqali to‘lash",
    "Personal data": "Shaxsiy ma’lumotlar",
    "All fields must be filled in using Latin letters": "Barcha maydonlar lotin harflarida to‘ldiriladi",
    "Passport series": "Pasport seriyasi",
    "Select a country": "Mamlakatni tanlang",
    "Child's personal data": "Bolaning shaxsiy ma’lumotlari",
    "Child's passport series": "Bola pasportining seriyasi",
    "Consent of the other parent": "Ikkinchi ota-onaning roziligi",
    "Seat booking": "Joylarni bron qilish",
    "The seats you selected have already been booked by other passengers": "Siz tanlagan joylarni boshqa yo‘lovchilar allaqachon bron qilgan",
    "Seat number": "Joy raqami",
    "You have successfully booked a seat": "Siz joyni muvaffaqiyatli bron qildingiz",
    "Your ID": "Sizning ID raqamingiz",
    "This seat is being booked by another user": "Bu joyni boshqa foydalanuvchi bron qilmoqda",
    "User": "Foydalanuvchi",
    "User role": "Foydalanuvchi roli",
    "Booking type": "Bron turi",
    "Domestic": "Ichki",
    "International": "Xalqaro",
    "Success": "Muvaffaqiyatli",
    "Operation completed successfully! The customer paid": "Amaliyot muvaffaqiyatli yakunlandi! Mijoz to‘ladi:",
    "An unexpected error occurred.": "Kutilmagan xatolik yuz berdi.",
    "Data was not saved!": "Ma’lumotlar saqlanmadi!",
    "Error receiving data from the server!": "Serverdan ma’lumot olishda xatolik yuz berdi!",
    "Unable to get DeviceId!": "DeviceId ni olib bo‘lmadi!",
    "Z report opened successfully!": "Z-hisobot muvaffaqiyatli ochildi!",
    "Error opening Z report!": "Z-hisobotni ochishda xatolik yuz berdi!",
    "Unable to save the receipt on the server!": "Chekni serverda saqlab bo‘lmadi!",
    "Error paying the receipt!": "Chekni to‘lashda xatolik yuz berdi!",
    "Only one seat can be selected!": "Faqat bitta joyni tanlash mumkin!",
    "Passenger number": "Yo‘lovchi raqami",
    "Full name is required": "F.I.Sh. kiritilishi shart",
    "All passenger data is required for international trips": "Xalqaro reyslarda yo‘lovchining barcha ma’lumotlari talab qilinadi",
    "All passenger and child data is required for international trips": "Xalqaro reyslarda yo‘lovchi va bolaning barcha ma’lumotlari talab qilinadi",
    "Full name must contain only Latin letters": "F.I.Sh. faqat lotin harflarida yozilishi kerak",
    "Passport details are invalid": "Pasport ma’lumotlari noto‘g‘ri",
    "Passport details are required": "Pasport ma’lumotlarini kiriting",
    "Child's full name must contain only Latin letters": "Bolaning F.I.Sh. faqat lotin harflarida yozilishi kerak",
    "International ticket": "Xalqaro reys chiptasi",
    "Domestic ticket": "Ichki reys chiptasi",
    "Bus station service": "Avtovokzal xizmati",
    "Conductor": "Konduktor",
    "Privilege found": "Imtiyoz topildi",
    "No privilege information found": "Imtiyoz haqida ma’lumot topilmadi",
    "Last privilege ticket": "Oxirgi imtiyozli chipta",
    "No privilege ticket history found": "Imtiyozli chipta tarixi mavjud emas",
    "Ticket number": "Chipta raqami",
    "Ticket date": "Chipta sanasi",
    "Route": "Yo‘nalish",
    "Ticket type": "Chipta turi",
    "Ticket cost": "Chipta narxi",
    "Paid amount": "To‘langan summa",
    "Privilege code": "Imtiyoz kodi",
    "Discount percent": "Chegirma foizi",
    "Trips per year": "Yiliga safarlar soni",
    "Discount note": "Imtiyoz bo'yicha izoh",
    "Privilege used": "Imtiyozdan foydalanilgan",
    "Privilege already used": "Ushbu imtiyozdan avval foydalanilgan",
    "Transport type": "Transport turi",
    "Ticket issue date": "Chipta berilgan sana",
    "Route type": "Yo‘nalish turi",
    "Ticket series and number": "Chipta seriyasi va raqami",
    "Full fare amount": "To‘liq yo‘l haqi",
    "Subsidy amount": "Subsidiya summasi",
    "Disability group": "Nogironlik guruhi",
    "Disability reason": "Nogironlik asosi",
    "Registration date": "Ro‘yxatga olingan sana",
    "Valid from": "Amal qilish boshlanishi",
    "Valid until": "Amal qilish muddati",
    "Document number": "Hujjat raqami",
    "Certificate number": "Guvohnoma raqami",
    "Organization": "Tashkilot",
    "Course": "Kurs",
    "Record": "Yozuv",
    "Privilege service unavailable": "Tekshiruv servisi hozir ishlamayapti. Keyinroq qayta urinib ko‘ring",
    "No privilege checks enabled": "Hozircha hech bir imtiyoz tekshiruvi yoqilmagan",
    "Privilege check incomplete": "Tekshiruv qisman bajarildi. Imtiyoz hali tasdiqlanmadi",
    "Vocational training status unconfirmed": "Kasb-hunar ta’limi holatini ushbu javob orqali tasdiqlab bo‘lmaydi",
    "No additional details available": "Qo‘shimcha ma’lumot mavjud emas",
    "Education type": "Ta’lim turi",
    "Education form": "Ta’lim shakli",
    "Education status": "Ta’lim holati",
    "Speciality": "Mutaxassislik",
    "Start year": "Boshlangan yil",
    "Survey ID": "So‘rovnoma raqami",
    "Poverty level": "Ijtimoiy toifa",
    "Registry status": "Reyestr holati",
    "Chernobyl radiation illness": "Chernobil AES halokati oqibatidagi nurlanish kasalligiga chalingan shaxslar",
    "Nuclear radiation veteran": "Yadro poligonlari va radiatsiya obyektlarida harbiy xizmatni o‘tagan nogironligi bo‘lgan pensionerlar",
    "Elderly disabled needing care": "O‘zgalar parvarishiga muhtoj yolg‘iz keksalar va nogironligi bo‘lgan shaxslar",
    "Accompanying person": "Yolg‘iz keksalar va nogironligi bo‘lgan shaxslarni hamrohlik qiluvchi shaxs",
    "Student": "Talabalar",
    "Disabled youth vocational training": "Nogironligi bo‘lgan yoshlarning kasb-hunar ta’limi",
    "Social registry youth competition": "Ijtimoiy reyestrdagi oilalarning 14–30 yosh a’zolari",
    "Social protection registry": "Ijtimoiy himoya reyestri",
    "World War II participants": "2-jahon urushida qatnashganlar"
};

export default data;
